//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { ReactComponent as ChevronSVG } from './chevron.svg';
import { useStore } from "../../store/store"
import styles from './styles.module.scss';

const LegalLayout = ({ children }) => {
  const [isVisible, setIsVisible] = useState(false);
  const { prevPage, setPage} = useStore()
  const handleScroll = () => {
    const currentScrollY = window.scrollY;
    if (currentScrollY > 200) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className={styles.layout}>
      <button className={styles.close} onClick={() => setPage(prevPage)}>
        <div />
        <div />
      </button>
      {children}
      {isVisible && (
        <button className={styles.scrollToTop} onClick={scrollToTop}>
          <ChevronSVG />
        </button>
      )}
    </div>
  );
};

export default LegalLayout;
